module.exports = __webpack_public_path__ + "static/site-1748442708190/img/left-arrow.4607435d.svg";